import { createSlice } from "@reduxjs/toolkit";
import {
  fetchImagingEarningsSummary,
  fetchImagingEarningsList,
} from "../../reducer/imagingServices/imagingEarningsReducer";

const imagingEarningsSlice = createSlice({
  name: "imagingEarnings",
  initialState: {
    summary: {},
    earnings: [],
    pagination: {},
    isLoading: false,
    isSummaryLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchImagingEarningsSummary.pending, (state) => {
        state.isSummaryLoading = true;
        state.error = null;
      })
      .addCase(fetchImagingEarningsSummary.fulfilled, (state, action) => {
        state.isSummaryLoading = false;
        state.summary = action.payload;
      })
      .addCase(fetchImagingEarningsSummary.rejected, (state, action) => {
        state.isSummaryLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchImagingEarningsList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchImagingEarningsList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.earnings = action.payload.earnings || [];
        state.pagination = action.payload.pagination || {};
      })
      .addCase(fetchImagingEarningsList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default imagingEarningsSlice.reducer;
